import { render } from "./InviteBulkLoadPage.vue?vue&type=template&id=1f948b14&ts=true"
import script from "./InviteBulkLoadPage.vue?vue&type=script&lang=ts"
export * from "./InviteBulkLoadPage.vue?vue&type=script&lang=ts"

import "./InviteBulkLoadPage.vue?vue&type=style&index=0&id=1f948b14&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__